import React, { useState, useRef, useEffect } from "react";

const ExpandableText = ({
  text = "N/A",
  maxHeightCollapsed = "40px", // Default height when collapsed
  maxHeightExpanded = "100px", // Max height when expanded (with scroll)
  endIndicator = "...", // What to show at the end: "..." or "view more" or custom text
  showToggle = false, // Whether to show a separate toggle button
  expandToFullHeight = false, // When true, expands to full height without scroll
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight, 10) || 20;
      const maxHeight = lineHeight * 2; // Allow only 2 lines initially
      setIsOverflowing(textRef.current.scrollHeight > maxHeight);
    }
  }, [text]);

  const expandText = () => {
    setIsExpanded(true); // Expand and do not allow collapsing
  };

  const getExpandedHeight = () => {
    if (expandToFullHeight) {
      return "auto"; // No height restriction, shows full text
    }
    return maxHeightExpanded; // Use the provided max height with scroll
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        ref={textRef}
        style={{
          overflow: isExpanded ? (expandToFullHeight ? "visible" : "auto") : "hidden",
          maxHeight: isExpanded ? getExpandedHeight() : maxHeightCollapsed,
          transition: "max-height 0.3s ease-in-out",
          paddingRight: isExpanded && !expandToFullHeight ? "8px" : "0", // Space for scrollbar only when needed
          border: isExpanded && !expandToFullHeight ? "1px solid #ccc" : "none", // Border only when scrollable
          borderRadius: "4px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: !isExpanded && isOverflowing ? 2 : "unset",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          cursor: !showToggle && isOverflowing && !isExpanded ? "pointer" : "default",
        }}
        onClick={!showToggle && !isExpanded && isOverflowing ? expandText : undefined}
      >
        {text}
        {!isExpanded && isOverflowing && !showToggle && (
          <span
            style={{
              color: "#3C6B49",
              fontWeight: "bold",
              cursor: "pointer",
              marginLeft: "4px",
            }}
            onClick={expandText}
          >
            {endIndicator}
          </span>
        )}
      </div>
      
      {/* Separate toggle button for better UX */}
      {showToggle && !isExpanded && isOverflowing && (
        <button
          onClick={expandText}
          style={{
            background: "none",
            border: "none",
            color: "#3C6B49",
            fontWeight: "bold",
            cursor: "pointer",
            padding: "4px 0",
            fontSize: "inherit",
            textDecoration: "underline",
            marginTop: "4px",
          }}
        >
          {endIndicator === "..." ? "View more" : endIndicator}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
